import { useCallback } from 'react';
import { UserRoles } from '@/models/company';

export const useEarningPermission = (userRole: UserRoles) => {
    const accessToUserEarningsAllowed = useCallback(
        (rowUserRole?: string) => {
            //IFs not combined to make it more readable
            if (userRole === UserRoles.SuperAdmin) {
                return true;
            }
            if (userRole == UserRoles.Admin && rowUserRole == UserRoles.User) {
                return true;
            }
            if (
                userRole == UserRoles.Admin &&
                rowUserRole == UserRoles.Manager
            ) {
                return true;
            }

            return false;
        },
        [userRole]
    );

    return { accessToUserEarningsAllowed };
};
